import { IUldRate } from "@cai-services";
export class UldRate implements IUldRate {
  amount: number;
  pivotWeight: number;
  overPivot: number;
  maxWeight: number;

  constructor (
    amount: number,
    pivotWeight: number,
    overPivot: number,
    maxWeight: number
  ) {
    this.amount = amount;
    this.pivotWeight = pivotWeight;
    this.overPivot = overPivot;
    this.maxWeight = maxWeight;
  }
}
